import { render, staticRenderFns } from "./hjx-header.vue?vue&type=template&id=107bbd0c&scoped=true&"
import script from "./hjx-header.vue?vue&type=script&lang=js&"
export * from "./hjx-header.vue?vue&type=script&lang=js&"
import style0 from "./hjx-header.vue?vue&type=style&index=0&id=107bbd0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107bbd0c",
  null
  
)

export default component.exports